webpackJsonp([265322141228615],{

/***/ 1095:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0039_oversized_rhinoceros.jpg","type":"Unit","subtype":"Rhino","cost":5,"ATK":7,"HP":8,"rules_text_1":null,"rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Oversized Rhinoceros","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"As rhinoceroses go, this rhinoceros is bigger than most rhinoceroses.","color":"Green","spec":"Growth","bottom":"Tech II","rulings":[],"keywords":[],"slug":"oversized_rhinoceros"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"oversized_rhinoceros","keywords":[],"imageRegex":"/oversized_rhinoceros.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-oversized-rhinoceros-db71f136ae0b590e31f1.js